import { NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { SizeType } from '@cf/core';
import { CfIconDirective } from '@cf/shared/ui/icons';
import { HslColorPipe } from '@cf/shared/ui/typography';
import { AccountService } from '@cf/temp/services';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
  selector: 'cf-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, MatTooltip, CfIconDirective, NgxTolgeeModule, HslColorPipe, NgClass],
  host: {
    '[style.--avatar-size]': '"var(--avatar-size-" + size + ")"',
  },
})
export class AvatarComponent {
  // eslint-disable-next-line no-untranslated-string/no-untranslated-string
  @Input() alt = 'Alt';

  @Input() src!: string;

  @Input() rounded = true;

  @Input() userName!: string | null;

  @Input() size: SizeType = 'md';

  @Input() has_any_calendar = false;

  fallbackClass = input('');

  constructor(public readonly accountService: AccountService) {}

  getNameInitials(name: string) {
    return name?.charAt(0);
  }
}
